<template>
  
    <b-modal
      hide-footer
      v-model="showRoomsetDeletor"
      @hidden="close"
      :title="$t('Delete Care Unit')">      
      <b-card >
        <h3>{{ $t('Confirmation before deletion') }}</h3>
        <p class="text-justify">
            {{ $t('This operation is irreversible.') }}
        </p>
        <p>{{$t('Please enter the Care Unit Name ') }} <i>{{$store.state.user.roomsetDeletorData ? $store.state.user.roomsetDeletorData.label : ''}}</i> {{ $t(' to confirm the deletion') }}.</p>
        <validation-observer ref="observer" v-slot="{ handleSubmit }" >
          <b-form @submit.stop.prevent="handleSubmit(apply)">
            <validation-provider
              :name="$t('Confirmation')"
              :rules="{ required: true, is:$store.state.user.roomsetDeletorData ? $store.state.user.roomsetDeletorData.label : 'mlkjmlkj' }"
              v-slot="validationContext"
            >
              <b-form-group
                label-cols-sm="3"
                :label="$t('Label:')"
                label-align-sm="left"
                label-for="label"
              >
                <b-form-input
                  v-model="label"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

                        
                <b-button  class="float-left" @click="close">
                    {{ $t('Cancel')}}
                </b-button>
                <b-button  :loading="requesting" variant="danger" class="float-right" type="submit">
                    {{ $t('Delete')}}
                </b-button>
            

          </b-form>
        </validation-observer>
      </b-card>
    </b-modal>  
</template>

<script>
import { AuthService } from '@/services/auth.service'
import { SPService } from "@/services/sp.service";
import { API_URL } from '@/.env'
export default  {
  components: {
    
  },  
  data() {
    return {
      showRoomsetDeletor: false     ,
      requesting: false, 
      label: null,
    }
  },
  watch : {
    '$store.state.user.roomsetDeletorShow': function(val) {               
        this.showRoomsetDeletor = val     
        this.requesting = false
    }
  },    
  methods: {
        close() {           
            this.$store.commit('user/SHOW_ROOMSETDELETOR',null);                        
        },
        getValidationState({ dirty, validated, valid = null }) {
          return dirty || validated ? valid : null;
        },
        async apply() {
          this.requesting = true
          let answer = await SPService.deleteRoomset(API_URL.url, this.$store.state.user.currentUser.jwt, this.$store.state.user.roomsetDeletorData.oid)
          if(answer.status !== 200)
            this.$store.commit('toast/NEW',{ status: 'error', message: `Error deleting user ${this.$store.state.user.roomsetDeletorData.label}`})
          else 
          {
            this.$store.commit('toast/NEW',{ status: 'success', message: `Care Unit ${this.$store.state.user.roomsetDeletorData ? this.$store.state.user.roomsetDeletorData.label : ''} is now deleted.`})
               
          }
          setTimeout(() => {
              this.$store.dispatch('fleet/shortPoll')
          },300) 
          this.requesting = false          
          this.$store.commit('user/SHOW_ROOMSETDELETOR',null);          
        }
    },
  mounted() {      
     this.label = '';
      this.$store.commit('user/SHOW_ROOMSETDELETOR',null);
  },
  name: "RoomsetDeletionModal"
}
</script>

<style lang="scss" scoped>

</style>
